import { RmaErrorsManagementState } from '../../types/RmaErrors';
import { unknown } from '../actions';
import { GlobalActionTypes } from '../types';
import { SET_IS_RMA_ERRORS_LOADING, RESET_STATE, RmaErrorManagementActionTypes, SET_RMA_TABLE_DATA } from './types';

export const initialState: RmaErrorsManagementState = {
  isRmaErrorsLoading: false,
  rmaErrors: null,
  total: 0,
  nextPageUrl: undefined,
};

export default (
  state = initialState,
  action: RmaErrorManagementActionTypes | GlobalActionTypes = unknown(),
): RmaErrorsManagementState => {
  switch (action.type) {
    case SET_RMA_TABLE_DATA: {
      const {
        payload: { rmaErrors, total, nextPageUrl },
      } = action;

      return {
        ...state,
        rmaErrors: [...(state.rmaErrors || []), ...rmaErrors],
        total,
        nextPageUrl,
      };
    }

    case SET_IS_RMA_ERRORS_LOADING: {
      const {
        payload: { isRmaErrorsLoading },
      } = action;

      return {
        ...state,
        isRmaErrorsLoading,
      };
    }

    case RESET_STATE: {
      return {
        ...state,
        rmaErrors: null,
        total: 0,
        nextPageUrl: undefined,
      };
    }

    default: {
      return state;
    }
  }
};
